// Export main ShopkitAnalytics component
export { default as ShopkitAnalytics, default } from "./ShopkitAnalytics";

export type {
  ShopkitAnalyticsConfig,
  ShopkitAnalyticsProps,
} from "./ShopkitAnalytics";

// Export event tracking functionality
export {
  eventPublisher,
  publishEvent,
  eventSubscriber,
  initializeEventTracking,
  initTracking,
} from "./events";
export type { TrackingAdapter } from "./events";

// Export affiliate tracking functionality
export {
  AffiliateTracker,
  useAffiliateTracker,
  useHasAffiliateData,
  useAffiliateSource,
  captureAffiliateParams,
  getAffiliateParams,
  clearAffiliateParams,
  hasAffiliateData,
  getAffiliateSource,
} from "./affiliate";
export type {
  AffiliateTrackerProps,
  AffiliateParams,
  AffiliateData,
  AffiliateConfig,
} from "./affiliate";

// Export shared types and constants
export * from "./types";
export * from "./constants";

// Export adapters
export * from "./adapters";

// Export logger
export * from "./logger";
